import { useState } from 'react';
import { WAEHRUNGEN, betrag, centAusText, kursAusTabelle, kursText, umrechnen } from '@beholder/shared/module/budget';
import { Auswahl, Eingabe, Feld, Karte, Knopf, Meldung, datum as datumText } from '../../core/ui';
import { useKurse } from './hilfe';

export function WaehrungsAuswahl({ wert, aendern, zusatz = [], id }: { wert: string; aendern(w: string): void; zusatz?: string[]; id?: string }) {
  const codes = [...new Set([...Object.keys(WAEHRUNGEN), ...zusatz, wert])].filter(Boolean);
  return (
    <Auswahl id={id} value={wert} onChange={(e) => aendern(e.target.value)}>
      {codes.map((c) => (
        <option key={c} value={c}>
          {c} – {WAEHRUNGEN[c] ?? 'andere Währung'}
        </option>
      ))}
    </Auswahl>
  );
}

/** Freier Währungsrechner mit EZB-Kursen (aktuell oder zu einem Tag). */
export function Rechner({ projektId, projektWaehrung }: { projektId: string; projektWaehrung: string }) {
  const [eingabe, setEingabe] = useState('100');
  const [von, setVon] = useState(projektWaehrung === 'USD' ? 'EUR' : 'USD');
  const [nach, setNach] = useState(projektWaehrung);
  const [tag, setTag] = useState('');
  const { kurse, fehler } = useKurse(projektId, tag || null);
  const cent = centAusText(eingabe);
  const kurs = kurse ? kursAusTabelle(kurse.jeEuro, von, nach) : null;

  return (
    <Karte titel="Währungsrechner" className="bu-rechner">
      <div className="bu-rechner-felder">
        <Feld titel="Betrag">
          <Eingabe inputMode="decimal" value={eingabe} onChange={(e) => setEingabe(e.target.value)} aria-invalid={cent === null} />
        </Feld>
        <Feld titel="von">
          <WaehrungsAuswahl wert={von} aendern={setVon} />
        </Feld>
        <Knopf
          klein
          art="leise"
          className="bu-tauschen"
          title="Währungen tauschen"
          aria-label="Währungen tauschen"
          onClick={() => {
            setVon(nach);
            setNach(von);
          }}
        >
          ⇄
        </Knopf>
        <Feld titel="nach">
          <WaehrungsAuswahl wert={nach} aendern={setNach} />
        </Feld>
        <Feld titel="Kurs vom" hinweis="leer = aktueller Kurs">
          <Eingabe type="date" value={tag} max={new Date().toISOString().slice(0, 10)} onChange={(e) => setTag(e.target.value)} />
        </Feld>
      </div>
      <Meldung>{fehler}</Meldung>
      <div className="bu-rechner-ergebnis" aria-live="polite">
        {cent === null ? (
          <span className="leise">Bitte einen Betrag eingeben, z. B. 1.234,50</span>
        ) : kurs ? (
          <>
            <strong>{betrag(cent, von)}</strong> = <strong className="bu-gross">{betrag(umrechnen(cent, kurs), nach)}</strong>
          </>
        ) : kurse ? (
          <span className="leise">Für diese Währung gibt es keinen EZB-Kurs.</span>
        ) : (
          <span className="leise">Kurse werden geladen …</span>
        )}
      </div>
      {kurs && kurse && (
        <p className="leise klein bu-ohne-abstand">
          {kursText(kurs, von, nach)} · EZB-Kurs vom {datumText(kurse.datum ?? '')}
          {kurse.stand === 'ersatz' && <span className="bu-marke bu-marke-warn">Kursquelle nicht erreichbar – letzter bekannter Kurs</span>}
        </p>
      )}
    </Karte>
  );
}
